'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});
var subscriptionTypes = {
	REACT_ONLY_ONCE: 'REACT_ONLY_ONCE',
	REACT_TO_LATEST: 'REACT_TO_LATEST'
};

exports.default = subscriptionTypes;